// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"0b599c19","33":"0576c38f","64":"ef9cb55a","488":"9b16b28a","501":"746d1bb2","508":"2cdd4685","659":"77580c62","923":"243dd1f1","970":"c2510b15"}[chunkId] + ".chunk.js";
};